// Mock data for Pam Immobilier website

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1659784314587-eee44d3426c9?w=1200&q=80",
    title: "Maison individuelle grand terrain et magnifique vue sur la campagne",
    description: "Située au bout d'un chemin pavé, cette belle propriété vous accueille dans un environnement paisible, sans vis-à-vis, avec une vue magnifique sur la campagne.",
    link: "/bien/1"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1586777469064-00eca3156523?w=1200&q=80",
    title: "Maison spacieuse de 257 m² habitables, lumineuse et tout confort",
    description: "Découvrez cette très jolie maison en PPE située à Fétigny, offrant à la fois des espaces généreux et de nombreux atouts.",
    link: "/bien/2"
  }
];

export const propertiesForSale = [
  {
    id: 1,
    title: "Maison individuelle grand terrain et magnifique vue sur la campagne",
    image: "https://images.unsplash.com/photo-1659784314587-eee44d3426c9?w=600&q=80",
    location: "Payerne, VD",
    price: 890000,
    rooms: 5.5,
    surface: 180,
    status: "en_vente",
    description: "Située au bout d'un chemin pavé, cette belle propriété vous accueille dans un environnement paisible.",
    features: ["Grand jardin", "Vue panoramique", "Garage double", "Cave à vin"]
  },
  {
    id: 2,
    title: "Maison spacieuse de 257 m² habitables, moderne et tout confort",
    image: "https://images.unsplash.com/photo-1586777469064-00eca3156523?w=600&q=80",
    location: "Fétigny, FR",
    price: 1250000,
    rooms: 7.5,
    surface: 257,
    status: "en_vente",
    description: "Découvrez cette très jolie maison en PPE offrant des espaces généreux.",
    features: ["Atelier chauffé", "Jardin", "Moderne", "Lumineux"]
  }
];

export const propertiesSold = [
  {
    id: 3,
    title: "Joli appartement de 6,5 pièces avec dépendances et vue panoramique",
    image: "https://images.unsplash.com/photo-1686056040370-b5e5c06c4273?w=600&q=80",
    location: "Treytorrens (Payerne)",
    price: 650000,
    rooms: 6.5,
    surface: 145,
    status: "vendu"
  },
  {
    id: 4,
    title: "Très jolie maison de 3 appartements avec grand jardin",
    image: "https://images.unsplash.com/photo-1659784305324-4c30efe004b6?w=600&q=80",
    location: "Seigneux",
    price: 980000,
    rooms: 9,
    surface: 320,
    status: "vendu"
  },
  {
    id: 5,
    title: "Maison spacieuse de 257 m² habitables, moderne et tout confort",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80",
    location: "Fétigny",
    price: 1100000,
    rooms: 7.5,
    surface: 257,
    status: "vendu"
  },
  {
    id: 6,
    title: "Jolie maison individuelle avec jardin à Surpierre",
    image: "https://images.unsplash.com/photo-1725138187136-790dc99ed924?w=600&q=80",
    location: "Surpierre",
    price: 720000,
    rooms: 5.5,
    surface: 160,
    status: "vendu"
  },
  {
    id: 7,
    title: "Spacieuse maison mitoyenne de 5,5 pièces à Rue",
    image: "https://images.unsplash.com/photo-1474144817891-babf8ac14ab0?w=600&q=80",
    location: "Rue, FR",
    price: 580000,
    rooms: 5.5,
    surface: 140,
    status: "vendu"
  },
  {
    id: 8,
    title: "Magnifique ferme avec vue panoramique à Rue",
    image: "https://images.unsplash.com/photo-1632743441209-8a09b8a37e25?w=600&q=80",
    location: "Rue, FR",
    price: 1450000,
    rooms: 10,
    surface: 450,
    status: "vendu"
  }
];

export const services = [
  {
    id: 1,
    title: "Estimation personnalisée",
    description: "Une estimation précise et personnalisée de votre bien immobilier basée sur le marché local.",
    icon: "Calculator"
  },
  {
    id: 2,
    title: "Accompagnement personnalisé",
    description: "Un suivi sur mesure tout au long de votre projet d'achat ou de vente.",
    icon: "Users"
  },
  {
    id: 3,
    title: "À votre écoute",
    description: "Une réelle envie de comprendre vos besoins et de les satisfaire au maximum dans votre projet immobilier.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Mise en valeur professionnelle",
    description: "Photos professionnelles et présentation optimale de votre bien sur les principales plateformes actives en Suisse romande.",
    icon: "Camera"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maillard Pierrot et Canisia",
    text: "En début d'année 2024, nous décidons la vente de notre villa située à Surpierre. Nous nous adressons à l'agence Pam immobilier courtage. Quel bon choix, à la rencontre d'une personne à l'écoute maîtrisant les dossiers et la connaissance des lois, avec toujours de bons conseils. Nous avons apprécié la ponctualité et le suivi du dossier. Nous recommandons vivement cette agence pour vos transactions immobilières.",
    rating: 5
  },
  {
    id: 2,
    name: "Famille Bader",
    text: "Très bon feeling, très compétente, Mme Moll a traité notre vente avec rapidité, professionnalisme et simplicité, commercialement au top, encore un grand merci.",
    rating: 5
  },
  {
    id: 3,
    name: "Lucien Bovey",
    text: "Très bon contact lors d'une demande d'estimation. Mme Moll a su répondre à toutes mes questions, la maison a été vendue au prix! Merci encore.",
    rating: 5
  },
  {
    id: 4,
    name: "Romuald Siggen",
    text: "Très bon contact avec Madame Moll. C'est une personne très professionnelle et très réactive. Une double transaction (achat et vente) a pu se faire simultanément. Nous recommandons vivement. Merci encore!",
    rating: 5
  },
  {
    id: 5,
    name: "Arménio Guerreiro",
    text: "Très content de la prestation de Mme Moll, professionnelle et à l'écoute. La maison a été vendue au bout de 2 à 3 semaines. Je recommande !",
    rating: 5
  },
  {
    id: 6,
    name: "Carol Soldati",
    text: "Professionnalisme, qualité-prix, réactivité.",
    rating: 5
  },
  {
    id: 7,
    name: "JP Wavre",
    text: "Merci à Mme Moll pour l'énergie et le temps passé sans compter ayant permis de réaliser l'achat de notre nouvelle maison.",
    rating: 5
  },
  {
    id: 8,
    name: "Shqipe Bytyqi",
    text: "Nous avons eu une magnifique collaboration dans le cadre de l'achat d'une maison. Madame Moll est très professionnelle et bienveillante. Nous la recommandons vivement.",
    rating: 5
  },
  {
    id: 9,
    name: "Piller Nicole et Raphaël",
    text: "Après avoir mandaté plusieurs courtiers en immobilier pour la vente de notre maison mais sans le succès escompté, nous avons rencontré l'agence PAM Immobilier Mme Pamela Moll. Pamela est une personne très sympathique qui nous a inspiré confiance dès notre première entrevue. Elle pratique son métier avec passion et grâce à son excellente connaissance professionnelle nous avons pu vendre notre maison très rapidement. Nous recommandons vivement cette agence pour tous projets immobiliers. Pamela nous te remercions pour tes conseils avisés.",
    rating: 5
  },
  {
    id: 10,
    name: "Zbinden Marthe et Michel",
    text: "Nous ne pouvons que recommander Madame Moll pour la vente de votre bien. Elle est dotée d'un professionnalisme extraordinaire et le contact avec elle est exceptionnel. Notre maison a été vendue au prix que nous avions décidé. Bravo Madame Moll, continuez comme ça, vous dégagez une telle confiance que nous avons beaucoup apprécié de travailler avec vous.",
    rating: 5
  },
  {
    id: 11,
    name: "Myriam Pache",
    text: "En quelques mois notre maison s'est vendu comme nous l'avions souhaité, Mme Moll a été d'un professionnalisme et d'une efficacité remarquable ! Nous vous la recommandons sans aucune hésitation.",
    rating: 5
  },
  {
    id: 12,
    name: "Anna Vulliemin",
    text: "Très bon contact dans le cadre de l'achat d'une maison, très professionnelle et sympathique. Nous la recommandons vivement.",
    rating: 5
  },
  {
    id: 13,
    name: "Fawer Pascal",
    text: "Très bon contact, service professionnel et agréable, notre maison a été vendue rapidement et au prix attendu.",
    rating: 5
  },
  {
    id: 14,
    name: "Béatrice Mieville",
    text: "Madame Moll est une grande professionnelle, a été réactive à bon escient et efficace dans les visites. Les conditions fixées ont été totalement respectées. Nous ne pouvons que recommander ses services.",
    rating: 5
  }
];

export const contactInfo = {
  name: "Pam Immobilier",
  phone: "+41 79 133 78 98",
  email: "info@pamimmobilier.ch"
};
